<template>
    <div class="grid">
        <div class="col-12">
            <Card id="toolbar">
                <template #title>
                    <Toolbar>
                        <template #right>
                            <div class="p-card-title" style="margin-top:10px;">
                                <Button label="Print" icon="pi pi-print pi-fw" class="p-button-success mr-2" @click="downloadPrint()" />
                                <Button v-if="this.$IS_PRINT_DOCUMENT == 'TRUE'" label="Pdf" icon="pi pi-file-pdf pi-fw" class="p-button-danger mr-2" @click="exportToPDF" />
                                <Button label="Back" icon="pi pi-chevron-left" class="p-button-primary"  @click="backToIndex" />
                            </div>
                        </template>
                    </Toolbar>
                </template>
            </Card>
            <div class="surface-0" style="background:white;padding:0;margin:0;">
                <div id="apps" class="center">
                    <table class="table"  ref="document" style="font-family:'Times New Roman', Times, serif;font-size:10px;width:100%;" v-if="dataDocument">
                    <colgroup>
                        <col style="width: 2%;">
                        <col style="width: 2%;">
                        <col style="width: 6%;">
                        <col style="width: 6%;">
                        <col style="width: 3%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                        <col style="width: 3.5%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th colspan="26" class="no-border"><p class="year"  style="text-align: right;">{{ dataDocument.location +", " + this.$formatDateName(dataDocument.Doc_Date)}}</p></th>
                        </tr>
                         <tr>
                            <th colspan="26" class="no-border" style="text-align:center;"><p style="font-size:20px;">RINCIAN KERJA TAMBAH KURANG<br/>
                                    <span style="font-size:15px;" v-if="dataDocument">No. Document: {{dataDocument.Doc_No}}</span>
                                </p>
                            </th>
                        </tr>
                        <tr style="height:15px;">
                            <td colspan="26" class="no-border"></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="3" class="no-border">Judul Pekerjaan</td>
                            <td colspan="23" class="no-border" v-if="dataDocument">: {{dataDocument!=null ? dataDocument.Deskripsi_Pekerjaan:""}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" class="no-border">Company</td>
                            <td colspan="23" class="no-border" v-if="dataDocument">: {{dataDocument!=null ? dataDocument.Company:""}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" class="no-border">Nama Kontractor</td>
                            <td colspan="23" class="no-border" v-if="dataDocument">: {{dataDocument!=null ? dataDocument.contractor:""}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" class="no-border">No. SPO</td>
                            <td colspan="23" class="no-border" v-if="dataDocument">: {{dataDocument!=null ? dataDocument.No_SPO:""}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" class="no-border">No. SPK</td>
                            <td colspan="23" class="no-border" v-if="dataDocument">: {{dataDocument!=null ? dataDocument.No_SPK:""}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" class="no-border">WBS Element</td>
                            <td colspan="23" class="no-border" v-if="dataDocument">: {{dataDocument!=null ? dataDocument.WBS_Allocation:""}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" class="no-border">Progress Actual</td>
                            <td colspan="23" class="no-border" v-if="dataDocument">: {{dataDocument!=null ? dataDocument.Current_MC + "%":""}}</td>
                        </tr>
                        <tr>
                            <td colspan="26" class="no-border">Perhitungan nilai tambah/kurang pada uraian di bawah ini berdasarkan pada hasil pemeriksaan MC- {{dataDocument!=null ? dataDocument.Current_MC :""}} yang dilaksanakan pada: {{this.$formatDate(dataDocument.Doc_Date_MC)}}
                                
                                
                            </td>
                        </tr>
                        <tr style="height:15px;">
                            <td colspan="26" class="no-border"></td>
                        </tr>
                        <tr style="text-align:center !important;font-weight:bold;" class="table-header">
                            <td rowspan="3" colspan="2" style="text-align:center !important;">No.</td>
                            <td rowspan="3" colspan="6" style="text-align:center !important;">Uraian Pekerjaan</td>
                            <td rowspan="3" colspan="1" style="text-align:center !important;">Satuan</td>
                            <td colspan="3" style="text-align:center !important;">Volume</td>
                            <td colspan="6" style="text-align:center !important;">{{dataDocument!=null ? dataDocument.signContract1:""}}</td>
                            <td colspan="6" style="text-align:center !important;">Actual {{dataDocument!=null ? dataDocument.signContract2:""}}</td>
                            <td colspan="2" style="text-align:center !important;">Deviasi</td>
                        </tr>
                        <tr style="text-align:center !important;font-weight:bold;" class="table-header"> 
                            <td rowspan="2" style="text-align:center !important;">RAB Awal</td>
                            <td rowspan="2" style="text-align:center !important;">Actual</td>
                            <td rowspan="2" style="text-align:center !important;">Deviasi</td>
                            <td colspan="4" style="text-align:center !important;">Unit Price</td>
                            <td rowspan="2" colspan="2" style="text-align:center !important;">Total</td>
                            <td colspan="4" style="text-align:center !important;">Unit Price</td>
                            <td rowspan="2" colspan="2" style="text-align:center !important;">Total</td>
                            <td rowspan="2" colspan="2" style="text-align:center !important;">Total</td>
                        </tr>
                        <tr style="text-align:center !important;font-weight:bold;" class="table-header"> 
                            <td colspan="2" style="text-align:center !important;">Material</td>
                            <td colspan="2" style="text-align:center !important;">Labour</td>
                            <td colspan="2" style="text-align:center !important;">Material</td>
                            <td colspan="2" style="text-align:center !important;">Labour</td>
                        </tr>
                        <tr v-for="(item, i) in dataDocument.ScopeMain" :key="item.Id" style="text-align:center;">
                            <td colspan="2">{{item.No_BoQ || ''}}</td>
                            <td colspan="6">{{item.Scope || ''}}</td>
                            <td>{{item.Unit || ''}}</td>
                            <td style="text-align:center !important;">{{item.Volume_Previous != null ? $formatDecimal(item.Volume_Previous) : ''}}</td>
                            <td style="text-align:center !important;">{{item.Volume_Current != null ? $formatDecimal(item.Volume_Current) : ''}}</td>
                            <td style="text-align:center !important;">{{item.Volume_Deviasi != null ? $formatDecimal(item.Volume_Deviasi) : ''}}</td>
                            <td colspan="2" style="text-align:center !important;">{{item.Material_Price != null ? item.Material_Price.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2}) : ''}}</td>
                            <td colspan="2" style="text-align:center !important;">{{item.Labour_Price != null ? item.Labour_Price.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2}) : ''}}</td>
                            <td colspan="2" style="text-align:right !important;">{{item.Amount_Previous != null ? item.Amount_Previous.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2}) : ''}}</td>
                            <td colspan="2" style="text-align:center !important;">{{item.Material_Price != null ? item.Material_Price.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2}) : ''}}</td>
                            <td colspan="2" style="text-align:center !important;">{{item.Labour_Price != null ? item.Labour_Price.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2}) : ''}}</td>
                            <td colspan="2" style="text-align:right !important;">{{item.Amount_Current != null ? item.Amount_Current.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2}) : ''}}</td>
                            <td colspan="2" style="text-align:center !important;">{{item.Amount_Deviasi != null ? item.Amount_Deviasi.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2}) : ''}}</td>
                        </tr>
                        <tr v-if="dataDocument.ScopeAdditional.length > 0">
                            <td colspan="26"><span style="font-weight: bold;">Pekerjaan tambah :</span> </td>
                        </tr>
                        <tr v-for="(item, i) in dataDocument.ScopeAdditional" :key="item.Id" style="text-align:center;">
                            <td colspan="2">{{item.No_BoQ || ''}}</td>
                            <td colspan="6">{{item.Scope || ''}}</td>
                            <td>{{item.Unit || ''}}</td>
                            <td style="text-align:center !important;">{{item.Volume_Previous != null ? $formatDecimal(item.Volume_Previous) : ''}}</td>
                            <td style="text-align:center !important;">{{item.Volume_Current != null ? $formatDecimal(item.Volume_Current) : ''}}</td>
                            <td style="text-align:center !important;">{{item.Volume_Deviasi != null ? $formatDecimal(item.Volume_Deviasi) : ''}}</td>
                            <td colspan="2" style="text-align:center !important;">{{item.Material_Price != null ? item.Material_Price.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2}) : ''}}</td>
                            <td colspan="2" style="text-align:center !important;">{{item.Labour_Price != null ? item.Labour_Price.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2}) : ''}}</td>
                            <td colspan="2" style="text-align:right !important;">{{item.Amount_Previous != null ? item.Amount_Previous.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2}) : ''}}</td>
                            <td colspan="2" style="text-align:center !important;">{{item.Material_Price != null ? item.Material_Price.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2}) : ''}}</td>
                            <td colspan="2" style="text-align:center !important;">{{item.Labour_Price != null ? item.Labour_Price.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2}) : ''}}</td>
                            <td colspan="2" style="text-align:right !important;">{{item.Amount_Current != null ? item.Amount_Current.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2}) : ''}}</td>
                            <td colspan="2" style="text-align:center !important;">{{item.Amount_Deviasi != null ? item.Amount_Deviasi.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2}) : ''}}</td>
                        </tr>
                        <tr>
                            <td colspan="12" style="text-align:center !important;">Total</td>
                            <td colspan="6" style="text-align:center !important;">Nilai Kontrak Awal</td>
                            <td colspan="6" style="text-align:center !important;">Nilai Actual {{dataDocument!=null ? dataDocument.name_Volume_Current:""}}</td>
                            <td colspan="2" style="text-align:center !important;">Nilai Deviasi</td>
                            
                        </tr>
                        <tr>
                            <td colspan="12"></td>
                            <td colspan="6" style="text-align:right !important;">{{dataDocument.Total_Initial_Contract != null ? dataDocument.Total_Initial_Contract.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 3}) : ''}}</td>
                            <td colspan="6" style="text-align:right !important;">{{dataDocument.Total_Actual_Contract != null ? dataDocument.Total_Actual_Contract.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 3}) : ''}}</td>
                            <td colspan="2" style="text-align:center !important;">{{dataDocument.Deviasi != null ? dataDocument.Deviasi.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2}) : ''}}</td>
                        </tr>
                        <tr>
                            <td colspan="18" style="text-align:center !important;"></td>
                            <td colspan="6" style="text-align:center !important;">Pembulatan</td>
                            <td colspan="2" style="text-align:center !important;">Deviasi</td>
                            
                        </tr>
                        <tr>
                             <td colspan="18" style="text-align:center !important;"></td>
                            <td colspan="6" style="text-align:right !important;">{{dataDocument.Rounding != null ? dataDocument.Rounding.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2}) : ''}}</td>
                            <td colspan="2" style="text-align:center !important;">{{dataDocument.Deviasi_Percent != null ? dataDocument.Deviasi_Percent.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 3}) + ' %' : ''}}</td>
                        </tr>

                        <tr style="height:15px;">
                            <td colspan="12" class="no-border"></td>
                        </tr>
                        <tr style="height:20px;">
                            <td colspan="26" class="no-border"></td>
                        </tr>
                        <tr  style="text-align:center;font-weight:bold;" class="signature-section">
                            <td class="no-border" colspan="8">Disiapkan Oleh,</td>
                            <td class="no-border"></td>
                            <td class="no-border" colspan="8">Diperiksa Oleh,</td>
                            <td class="no-border"></td>
                            <td class="no-border" colspan="8">Disetujui Oleh,</td>
                        </tr>
                        <tr style="text-align:center;font-weight:bold;" class="signature-section">
                            <td class="no-border" colspan="8">
                                {{dataDocument!=null ? dataDocument.contractor:""}}
                            </td>
                            <td class="no-border"></td>
                            <td class="no-border" colspan="8">
                                {{dataDocument!=null ? dataDocument.Company:""}}
                            </td>
                            <td class="no-border"></td>
                            <td class="no-border" colspan="8">
                                {{dataDocument!=null ? dataDocument.Company:""}}
                            </td>
                        </tr>
                        <tr style="text-align:center;" class="signature-section">
                            <td class="no-border" colspan="8">
                                <br/><span class="fontsign">{{ dataDocument.Appr_Name1 || '' }} </span><br/>
                                <!-- <span>({{ dataDocument!=null ? dataDocument.Appr_Name1:"" }})</span> -->
                            </td>
                            <td class="no-border"></td>
                            <td class="no-border" colspan="8">
                                <br/><span class="fontsign">{{ dataDocument.Appr_Name2 || '' }} </span><br/>
                                <!-- <span>({{ dataDocument!=null ? dataDocument.Appr_Name2:"" }})</span> -->
                            </td>
                            <td class="no-border"></td>
                            <td class="no-border" colspan="8">
                                <br/><span class="fontsign">{{ dataDocument.Appr_Name3 || '' }} </span><br/>
                                <!-- <span>({{ dataDocument!=null ? dataDocument.Appr_Name3:"" }})</span> -->
                            </td>
                        </tr>
                        <tr style="text-align:center;font-weight:bold;" class="signature-section">
                            <td class="no-border" colspan="8">
                                <span>{{this.$formatDateTime1(dataDocument.ApprDate1)}}</span>
                                <hr>
                                {{ labelAppr1 }}
                            </td>
                            <td class="no-border"></td>
                            <td class="no-border" colspan="8">
                                <span>{{this.$formatDateTime1(dataDocument.ApprDate2)}}</span>
                                <hr>
                                {{ labelAppr2 }}
                            </td>
                            <td class="no-border"></td>
                            <td class="no-border" colspan="8">
                                <span>{{this.$formatDateTime1(dataDocument.ApprDate3)}}</span>
                                <hr>
                                {{ labelAppr3 }}
                            </td>
                        </tr>
                        <tr style="height:15px;">
                            <td colspan="12" class="no-border"></td>
                        </tr>
                    </tbody>
                        <tr>
                            <td colspan="10" style="border: none;" class="tdfoot">
                                <img src="/assets/layout/images/stamp-draft.png" height="120" width="140" v-if="dataDocument.Status == this.$REQUEST_STATUS.DRAFT|| dataDocument.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || dataDocument.Status == this.$APPROVAL_STATUS.REVISED"/>
                            </td>
                            <td colspan="16" style="border: none;" class="tdfoot">
                                <VueQrcode :value="valueLink" style="width:85px;float:right;" id="qr"></VueQrcode>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="26" style="border: none;" v-if="dataDocument.is_aproved">
                                <p style="font-size:10px;">
                                    <b>
                                        {{ 
                                            this.signBy(dataDocument)
                                        
                                        }}

                                    </b>
                                </p>
                            </td>
                        </tr>
                        <tr style="height: 30px;" v-if="dataDocument.is_aproved">
                            <td style="border: none;"></td>
                        </tr>
                        <tr style="height: 20px;" v-else>
                            <td style="border: none;"></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import html2pdf from 'html2pdf.js'

export default{
data(){
    return {
        listDoc : null,
        dataheader : null,
        title : "listdocuments",
        docvalidity : [],
        compCode : "",
        dataDocument:null,
        listPicAppr:null,
        imgdocumentation : "",
        companydetail : null,
        is_receive :false,
        is_not_receive : false,
        valueLink : this.$store.getters.getUrlApp + this.$route.fullPath,
        labelAppr1 : "",
        labelAppr2 : "",
        labelAppr3 : "",
        labelAppr4 : "",
        labelAppr5 : "",
    }
},
methods:{
    signBy(data){
        this.signby = `${this.$DOCUMENTFOOTER.APPROVED_GENERATED} (Document Print by ${this.$store.getters.getFullname} at ${this.$formatDateTime2(new Date())})`; 
        return this.signby;
    },
    backToIndex(){
        this.$router.replace({ path: "/AddendumMC/Index", query: { activeIndex: 1 } });
    },

        downloadPrint(){
        this.$emit('block-ui');
            var self = this;
                const link = this.valueLink;
                this.$axios.get(this.$API_URL + "AddendumMC/" + "downloadprintRKTK", {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG,
                params : {
                    id : this.id,
                    linqr : link,
                    signby : this.signby,
                }  
                })
                .then((response) => {
                    let fileName = response.headers["content-disposition"].split("filename=")[1].split(";")[0];

                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const url = URL.createObjectURL(blob);
                    window.open(url, '_blank');
                    self.$emit('unblock-ui');
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    self.$emit('unblock-ui');
                });
    },

    printWindow() {
        this.addPagenumber();
        window.print();
        this.removePageNumbers();
    },
    addPagenumber(){
        let pageNumber = 1;
        var table = this.$refs.document;
        var scrollHeight = table.offsetHeight;
        var totalPages = Math.ceil(table.scrollHeight / 1123);
        for (let i = 0; i < totalPages; i++) {
            var pageNumberDiv = document.createElement("div");
            var pgNum = document.createTextNode("" + (i+1) + "/" + totalPages);
            pageNumberDiv.classList.add('page-number');
            pageNumberDiv.style.position = "absolute";
            pageNumberDiv.style.top = "calc((281mm - (0.5px + " + (i+1) +"px)) * " + (i+1)+ " - 31px)";
            pageNumberDiv.style.right = 0;
            pageNumberDiv.style.height = "12px";
            pageNumberDiv.appendChild(pgNum);
            document.body.appendChild(pageNumberDiv);
            
        }
    },
    removePageNumbers() {
        const pageNumberElements = document.querySelectorAll('.page-number');
        pageNumberElements.forEach(element => element.remove());
    },
    exportToPDF() {
        const filename = this.dataDocument ? `RKTK_${this.dataDocument.Doc_No}.pdf` : 'RKTK.pdf';
        html2pdf(this.$refs.document, {
            margin: [8, 10, 8, 10],
            filename: filename,
            image: { type: 'jpeg', quality: 0.98},
            html2canvas: { 
                scale: 2,
                useCORS: true,
                letterRendering: true
            },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        })
    },
    getData() {
            this.$emit('block-ui');
            let self = this;
            self.$axios.get(this.$API_URL + "AddendumMC/getDataDocRKTK/"+ this.$route.query.id 
            ).then((response) => {
                var data = response.data.data;
                self.dataDocument = data.document;
                self.listPicAppr = data.listPicAppr;
                var listAppr = self.listPicAppr;
                if(listAppr.length > 0)
                {
                        listAppr.forEach(a=>{
                            if(a.Sign_Position == 1){
                                self.labelAppr1 = a.Approval_As;
                                self.dataDocument.Appr_As1 = a.Approval_As;
                                self.dataDocument.Sign_Position1 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 2){
                                self.labelAppr2 = a.Approval_As;
                                self.dataDocument.Appr_As2 = a.Approval_As;
                                self.dataDocument.Sign_Position2 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 3){
                                self.labelAppr3 = a.Approval_As;
                                self.dataDocument.Appr_As3 = a.Approval_As;
                                self.dataDocument.Sign_Position3 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 4){
                                self.labelAppr4 = a.Approval_As;
                                self.dataDocument.Appr_As4 = a.Approval_As;
                                self.dataDocument.Sign_Position4 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 5){
                                self.labelAppr5 = a.Approval_As;
                                self.dataDocument.Appr_As5 = a.Approval_As;
                                self.dataDocument.Sign_Position5 =  a.Sign_Position;
                            }
                        });
                }
                self.$emit('unblock-ui');
            
            }).catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 6000 });
                    self.$emit('unblock-ui');
            });
        },
    },
    computed:{
    },   
    created() {
            this.mode = this.$route.query.mode;
            this.id = this.$route.query.id ?? 0;
            this.getData();
        },
}
</script>
<style>

@page {
    size: A4 landscape !important;
    margin: 8mm 10mm;
}

@media print {
    * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
    
    body {
        float: none;
        margin: 0;
        padding: 0;
        counter-reset: section;
        width: 100%;
        background: white !important;
    }
    
    #content {
        display: table;
    }
    
    #pageFooter {
        display: table-footer-group;
    }
    
    #pageFooter:after {
        counter-increment: page;
        content: counter(page);
    }
   
    #app .layout-wrapper .p-blockui-container .layout-topbar{
        display: none;
    }

    #app .layout-wrapper .p-blockui-container .layout-sidebar{
        display: none;
        margin: 0;
    }

    #app .layout-wrapper .p-blockui-container .layout-footer{
        display: none;
        margin: 0;
    }

    #app .layout-wrapper .p-blockui-container .layout-main-container{
        padding: 0;
        margin: 0;
        width: 100%;
        background: white !important;
     }
     
    .surface-0 {
        margin: 0;
        padding: 0;
        background: white !important;
    }
    
    * {
        background: white !important;
    }
    
    #apps {
        background: white !important;
    }
    
    table {
        page-break-inside: auto;
    }
    
    tr {
        page-break-inside: avoid;
        page-break-after: auto;
    }
    
    tbody {
        page-break-inside: auto;
    }
    
    thead {
        display: table-header-group;
    }
    
    tfoot {
        display: table-footer-group;
    }
}
@media screen and (max-width: 64em) {
    .p-sidebar-left.p-sidebar-lg,
    .p-sidebar-left.p-sidebar-md,
    .p-sidebar-right.p-sidebar-lg,
    .p-sidebar-right.p-sidebar-md {
        width: 20rem;
    }
}
#apps{
    width: 80%;
}

</style>
<style scoped>
@media print {
    tfoot {
      position: fixed;
      bottom: 0;
      width: 100%;
    }

    .tdfoot{
        width: 100%;
    }

    #toolbar{
        display: none;
    }
    #display{
        display: none;
    }

    body{
      width: 100%;
      margin: 0;
      padding: 0;
      background: white !important;
    }

    #apps{
        width: 100%;
        margin: 0;
        padding: 0;
    }
    
    .grid {
        margin: 0;
        padding: 0;
        background: white !important;
    }
    
    .col-12 {
        padding: 0;
        margin: 0;
        background: white !important;
    }
    
    .surface-0 {
        background: white !important;
        margin: 0;
        padding: 0;
    }
    
    .pagebreak{
        page-break-after: always;
    }
    .tfoot{
        width: 97.20%;
        position: fixed;
        bottom: 0;
        left: 10px;
        right: 0;
    }
    
    .table td, .table th {
        padding: 2px 3px !important;
        font-size: 9px !important;
        line-height: 1.2;
    }
    
    .table {
        width: 100% !important;
    }
    
    .table thead th {
        font-size: 10px !important;
    }
}
.table .no-border {
    border: none;
  }
.crossed
{
    background: linear-gradient(to bottom right, transparent 49.5%, black 49.5%, black 50.5%, transparent 50.5%) !important;
}

.table {
    border-collapse: collapse;
    width: 100%;
    color: black;
    table-layout: fixed;
}

/* Ensure equal column distribution for signature sections */
.signature-section {
    width: 100%;
    page-break-inside: avoid !important;
}

.signature-section td {
    text-align: center !important;
    vertical-align: middle;
    padding: 8px 4px;
}

/* Force center alignment for all signature section content */
.signature-section {
    width: 100%;
    text-align: center;
    page-break-inside: avoid !important;
}

.signature-section td, .signature-section th {
    text-align: center !important;
}

/* Force center alignment for table headers */
.table-header {
    text-align: center !important;
}

.table-header td, .table-header th {
    text-align: center !important;
    vertical-align: middle;
}
.table .th {
    padding-top: 12px;
    padding-bottom: 12px;
}
  /* #f9f340*/
.table .center{
    text-align: center;
}
.table td, .table th {
    border: 1px solid black;
    word-wrap: break-word;
    overflow-wrap: break-word;
    padding: 4px;
    vertical-align: top;
    text-align: left;
}

.table td[style*="text-align:center"], .table th[style*="text-align:center"] {
    text-align: center !important;
}

.ol {
    display: block;
    list-style-type: decimal;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 12px;
    margin-top:-10px;
}

hr{
    padding: 0.3px;
    border-bottom: 1.8px solid black;
    margin : 0 auto;
    width:110px;
   }



#toolbar{
    max-height: 90px;
}

.title{
    font-size: 20px;
}
.year{
    margin-left: 290px;
}
.center{
    margin: auto;
}
.p1 {
    width: 70%; /* Add a width to demonstrate text wrapping */
    margin: auto;
    white-space: normal;
    font-size:14px;
  }
  .widht1{
    width: 70%; /* Add a width to demonstrate text wrapping */
    margin: auto;
  }
  .fontsign{
    font-family: 'Monotype Corsiva'
  }
</style>